import { axiosClassic } from '@/services/axiosConfig';
import axios, { AxiosResponse } from 'axios';

async function CreateBlob(response: AxiosResponse): Promise<string> {
  let scriptURL = '';
  const data = response.data;
  try {
    const jsCodeMatches = data.match(/<!-- <JS> -->([\s\S]*?)<!-- <\/JS> -->/);
    if (jsCodeMatches) {
      const jsCode = jsCodeMatches[1].replace(/<[^>]+>/g, '');

      const blob = new Blob([jsCode], { type: 'text/javascript' });
      scriptURL = URL.createObjectURL(blob);
      // console.log('Added Blob Script:', blob);
    } else {
      // console.log('No JS code matches found in the API response.');
    }
  } catch (error) {
    console.error('Error fetching or processing the API response:', error);
  }

  // console.groupEnd();

  return scriptURL;
}

async function ReturnBlob(response: AxiosResponse): Promise<Blob> {
  const data = response.data;
  try {
    const jsCodeMatches = data.match(/<!-- <JS> -->([\s\S]*?)<!-- <\/JS> -->/);
    if (jsCodeMatches) {
      const jsCode = jsCodeMatches[1].replace(/<[^>]+>/g, '');

      const blob = new Blob([jsCode], { type: 'text/javascript' });
      return blob;
      //  console.log('Added Blob Script:', blob);
    } else {
      //  console.log('No JS code matches found in the API response.');
    }
  } catch (error) {
    console.error('Error fetching or processing the API response:', error);
  }

  // console.groupEnd();

  return new Blob();
}

async function ReturnJSCode(response: AxiosResponse): Promise<any> {
  const data = response.data;
  try {
    const jsCodeMatches = data.match(/<!-- <JS> -->([\s\S]*?)<!-- <\/JS> -->/);
    if (jsCodeMatches) {
      const regex = /<\/script>|<script\b[^>]*>|<script\b[^>]*type="text\/javascript"[^>]*>/gi;
      const jsCode = jsCodeMatches[1].replace(regex, '');
      return jsCode;
    } else {
      //  console.log('No JS code matches found in the API response.');
    }
  } catch (error) {
    console.error('Error fetching or processing the API response:', error);
  }

  // console.groupEnd();

  return '';
}

async function ReturnJSDefs(response: AxiosResponse): Promise<any> {
  const data = response.data;

  //get first script tag from the response data
  const scriptMatches = data.match(/<script[^>]*>([\s\S]*?)<\/script>/);
  if (scriptMatches) {
    const regex = /<\/script>|<script\b[^>]*>|<script\b[^>]*type="text\/javascript"[^>]*>/gi;
    const script = scriptMatches[1].replace(regex, '');
    return script;
  } else {
    // console.log('No script tags found in the API response.');
  }

  console.groupEnd();

  return '';
}

export { CreateBlob, ReturnBlob, ReturnJSCode, ReturnJSDefs };
